var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Name=google, Type=circle, Color Type=multicolour"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M68.5493 34.2048C68.5493 15.4272 53.327 0.204834 34.5493 0.204834C15.7716 0.204834 0.549316 15.4272 0.549316 34.2048C0.549316 52.9825 15.7716 68.2048 34.5493 68.2048C53.327 68.2048 68.5493 52.9825 68.5493 34.2048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "google",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1877 34.5912C51.1877 33.3858 51.0795 32.2267 50.8786 31.114H34.8677V37.6899H44.0168C43.6227 39.8149 42.425 41.6153 40.6245 42.8208V47.0863H46.1186C49.3332 44.1267 51.1877 39.7685 51.1877 34.5912Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "google_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8667 51.2048C39.4567 51.2048 43.3049 49.6825 46.1176 47.0861L40.6235 42.8207C39.1012 43.8407 37.1539 44.4434 34.8667 44.4434C30.4389 44.4434 26.6912 41.4529 25.3544 37.4348H19.6748V41.8393C22.4721 47.3952 28.2212 51.2048 34.8667 51.2048Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "google_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3554 37.4348C25.0154 36.4148 24.8222 35.3252 24.8222 34.2048C24.8222 33.0843 25.0154 31.9947 25.3554 30.9747V26.5702H19.6759C18.5245 28.8652 17.8677 31.4616 17.8677 34.2048C17.8677 36.9479 18.5245 39.5443 19.6759 41.8393L25.3554 37.4348Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "google_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8667 23.9663C37.3626 23.9663 39.6035 24.824 41.3653 26.5086L46.2412 21.6326C43.2971 18.8894 39.4489 17.2049 34.8667 17.2049C28.2212 17.2049 22.4721 21.0144 19.6748 26.5704L25.3544 30.9749C26.6912 26.9567 30.4389 23.9663 34.8667 23.9663Z",
    fill: "#EA4335"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleColor);
export default __webpack_public_path__ + "static/media/google-color.a909820f71b7b910bad452e8f6ca83d9.svg";
export { ForwardRef as ReactComponent };